import { transform } from '@utils/intl_lang';
export default {
  data: [
    {
      country: 'China',
      // '中国'
      chName: transform('areaCode_China'),
      countryCode: 'CN',
      code: '86',
    },
    {
      country: 'Macau',
      // '中国澳门'
      chName: transform('areaCode_Macau'),
      countryCode: 'MO',
      code: '853',
    },
    {
      country: 'Taiwan',
      // '中国台湾'
      chName: transform('areaCode_Taiwan'),
      countryCode: 'TW',
      code: '886',
    },
    {
      country: 'Hong Kong',
      // '中国香港'
      chName: transform('areaCode_HongKong'),
      countryCode: 'HK',
      code: '852',
    },
    {
      country: 'Albania',
      // '阿尔巴尼亚'
      chName: transform('areaCode_Albania'),
      countryCode: 'AL',
      code: '355',
    },
    {
      country: 'Algeria',
      // '阿尔及利亚'
      chName: transform('areaCode_Algeria'),
      countryCode: 'DZ',
      code: '213',
    },
    {
      country: 'Afghanistan',
      // '阿富汗'
      chName: transform('areaCode_Afghanistan'),
      countryCode: 'AF',
      code: '93',
    },
    {
      country: 'Argentina',
      // '阿根廷'
      chName: transform('areaCode_Argentina'),
      countryCode: 'AR',
      code: '54',
    },
    {
      country: 'United Arab Emirates',
      // '阿拉伯联合酋长国'
      chName: transform('areaCode_UnitedArabEmirates'),
      countryCode: 'AE',
      code: '971',
    },
    {
      country: 'Aruba',
      // '阿鲁巴'
      chName: transform('areaCode_Aruba'),
      countryCode: 'AW',
      code: '297',
    },
    // '阿曼'
    { country: 'Oman', chName: transform('areaCode_Oman'), countryCode: 'OM', code: '968' },
    {
      country: 'Azerbaijan',
      // '阿塞拜疆'
      chName: transform('areaCode_Azerbaijan'),
      countryCode: 'AZ',
      code: '994',
    },
    // '埃及'
    { country: 'Egypt', chName: transform('areaCode_Egypt'), countryCode: 'EG', code: '20' },
    {
      country: 'Ethiopia',
      // '埃塞俄比亚'
      chName: transform('areaCode_Ethiopia'),
      countryCode: 'ET',
      code: '251',
    },
    {
      country: 'Ireland',
      // '爱尔兰'
      chName: transform('areaCode_Ireland'),
      countryCode: 'IE',
      code: '353',
    },
    {
      country: 'Estonia',
      // '爱沙尼亚'
      chName: transform('areaCode_Estonia'),
      countryCode: 'EE',
      code: '372',
    },
    {
      country: 'Andorra',
      // '安道尔'
      chName: transform('areaCode_Andorra'),
      countryCode: 'AD',
      code: '376',
    },
    {
      country: 'Angola',
      // /'安哥拉'
      chName: transform('areaCode_Angola'),
      countryCode: 'AO',
      code: '244',
    },
    {
      country: 'Anguilla',
      // /'安圭拉'
      chName: transform('areaCode_Anguilla'),
      countryCode: 'AI',
      code: '1264',
    },
    {
      country: 'Antigua and Barbuda',
      // '安提瓜和巴布达'
      chName: transform('areaCode_AntiguaAndBarbuda'),
      countryCode: 'AG',
      code: '1268',
    },
    {
      country: 'Austria',
      // '奥地利'
      chName: transform('areaCode_Austria'),
      countryCode: 'AT',
      code: '43',
    },
    {
      country: 'Australia',
      // '澳大利亚'
      chName: transform('areaCode_Australia'),
      countryCode: 'AU',
      code: '61',
    },
    {
      country: 'Barbados',
      // '巴巴多斯'
      chName: transform('areaCode_Barbados'),
      countryCode: 'BB',
      code: '1246',
    },
    {
      country: 'Papua New Guinea',
      // '巴布亚新几内亚'
      chName: transform('areaCode_PapuaNewGuinea'),
      countryCode: 'PG',
      code: '675',
    },
    {
      country: 'Bahamas',
      // '巴哈马'
      chName: transform('areaCode_Bahamas'),
      countryCode: 'BS',
      code: '1242',
    },
    {
      country: 'Pakistan',
      // '巴基斯坦'
      chName: transform('areaCode_Pakistan'),
      countryCode: 'PK',
      code: '92',
    },
    {
      country: 'Paraguay',
      // '巴拉圭'
      chName: transform('areaCode_Paraguay'),
      countryCode: 'PY',
      code: '595',
    },
    {
      country: 'Palestine',
      // '巴勒斯坦'
      chName: transform('areaCode_Palestine'),
      countryCode: 'BL',
      code: '970',
    },
    {
      country: 'Bahrain',
      // '巴林'
      chName: transform('areaCode_Bahrain'),
      countryCode: 'BH',
      code: '973',
    },
    {
      country: 'Panama',
      // '巴拿马'
      chName: transform('areaCode_Panama'),
      countryCode: 'PA',
      code: '507',
    },
    {
      country: 'Brazil',
      // '巴西'
      chName: transform('areaCode_Brazil'),
      countryCode: 'BR',
      code: '55',
    },
    {
      country: 'Belarus',
      // '白俄罗斯'
      chName: transform('areaCode_Belarus'),
      countryCode: 'BY',
      code: '375',
    },
    {
      country: 'Bermuda',
      // /'百慕大群岛'
      chName: transform('areaCode_Bermuda'),
      countryCode: 'BM',
      code: '1441',
    },
    {
      country: 'Bulgaria',
      // '保加利亚'
      chName: transform('areaCode_Bulgaria'),
      countryCode: 'BG',
      code: '359',
    },
    {
      country: 'Benin',
      // '贝宁'
      chName: transform('areaCode_Benin'),
      countryCode: 'BJ',
      code: '229',
    },
    {
      country: 'Belgium',
      // '比利时'
      chName: transform('areaCode_Belgium'),
      countryCode: 'BE',
      code: '32',
    },
    {
      country: 'Iceland',
      // '冰岛'
      chName: transform('areaCode_Iceland'),
      countryCode: 'IS',
      code: '354',
    },
    {
      country: 'Puerto Rico',
      // '波多黎各'
      chName: transform('areaCode_PuertoRico'),
      countryCode: 'PR',
      code: '1787',
    },
    {
      country: 'Poland',
      // '波兰'
      chName: transform('areaCode_Poland'),
      countryCode: 'PL',
      code: '48',
    },
    {
      country: 'Bosnia and Herzegovina',
      // '波斯尼亚和黑塞哥维'
      chName: transform('areaCode_BosniaandHerzegovina'),
      countryCode: 'BA',
      code: '387',
    },
    {
      country: 'Bolivia',
      // '玻利维亚'
      chName: transform('areaCode_Bolivia'),
      countryCode: 'BO',
      code: '591',
    },
    {
      country: 'Belize',
      // /'伯利兹'
      chName: transform('areaCode_Belize'),
      countryCode: 'BZ',
      code: '501',
    },
    {
      country: 'Botswana',
      // '博茨瓦纳'
      chName: transform('areaCode_Botswana'),
      countryCode: 'BW',
      code: '267',
    },
    {
      country: 'Bhutan',
      // '不丹'
      chName: transform('areaCode_Bhutan'),
      countryCode: 'BT',
      code: '975',
    },
    {
      country: 'Burkina Faso',
      // '布基纳法索'
      chName: transform('areaCode_BurkinaFaso'),
      countryCode: 'BF',
      code: '226',
    },
    {
      country: 'Burundi',
      // '布隆迪'
      chName: transform('areaCode_Burundi'),
      countryCode: 'BI',
      code: '257',
    },
    {
      country: 'Equatorial Guinea',
      // '赤道几内亚'
      chName: transform('areaCode_EquatorialGuinea'),
      countryCode: 'GQ',
      code: '240',
    },
    {
      country: 'Denmark',
      // '丹麦'
      chName: transform('areaCode_Denmark'),
      countryCode: 'DK',
      code: '45',
    },
    {
      country: 'Germany',
      // '德国'
      chName: transform('areaCode_Germany'),
      countryCode: 'DE',
      code: '49',
    },
    {
      country: 'Timor-Leste',
      // '东帝汶'
      chName: transform('areaCode_TimorLeste'),
      countryCode: 'TL',
      code: '670',
    },
    // '多哥'
    { country: 'Togo', chName: transform('areaCode_Togo'), countryCode: 'TG', code: '228' },
    {
      country: 'Dominica',
      // '多米尼加'
      chName: transform('areaCode_Dominica'),
      countryCode: 'DM',
      code: '1767',
    },
    {
      country: 'Dominican Republic',
      // /'多米尼加共和国'
      chName: transform('areaCode_DominicanRepublic'),
      countryCode: 'DO',
      code: '1809',
    },
    {
      country: 'Russia',
      // '俄罗斯'
      chName: transform('areaCode_Russia'),
      countryCode: 'RU',
      code: '7',
    },
    {
      country: 'Ecuador',
      // '厄瓜多尔'
      chName: transform('areaCode_Ecuador'),
      countryCode: 'EC',
      code: '593',
    },
    {
      country: 'Eritrea',
      // '厄立特里亚'
      chName: transform('areaCode_Eritrea'),
      countryCode: 'ER',
      code: '291',
    },
    {
      country: 'France',
      // '法国'
      chName: transform('areaCode_France'),
      countryCode: 'FR',
      code: '33',
    },
    {
      country: 'Faroe Islands',
      // '法罗群岛'
      chName: transform('areaCode_FaroeIslands'),
      countryCode: 'FO',
      code: '298',
    },
    {
      country: 'French Polynesia',
      // '法属波利尼西亚'
      chName: transform('areaCode_FrenchPolynesia'),
      countryCode: 'PF',
      code: '689',
    },
    {
      country: 'French Guiana',
      // '法属圭亚那'
      chName: transform('areaCode_FrenchGuiana'),
      countryCode: 'GF',
      code: '594',
    },
    {
      country: 'Philippines',
      // '菲律宾'
      chName: transform('areaCode_Philippines'),
      countryCode: 'PH',
      code: '63',
    },
    // '斐济'
    { country: 'Fiji', chName: transform('areaCode_Fiji'), countryCode: 'FJ', code: '679' },
    {
      country: 'Finland',
      // '芬兰'
      chName: transform('areaCode_Finland'),
      countryCode: 'FI',
      code: '358',
    },
    {
      country: 'Gambia',
      // '冈比亚'
      chName: transform('areaCode_Gambia'),
      countryCode: 'GM',
      code: '220',
    },
    {
      country: 'Republic Of The Congo',
      // '刚果共和国'
      chName: transform('areaCode_RepublicOfTheCongo'),
      countryCode: 'CG',
      code: '242',
    },
    {
      country: 'Democratic Republic of',
      // '刚果民主共和国'
      chName: transform('areaCode_DemocraticRepublicof'),
      countryCode: 'CD',
      code: '243',
    },
    {
      country: 'Colombia',
      // '哥伦比亚'
      chName: transform('areaCode_Colombia'),
      countryCode: 'CO',
      code: '57',
    },
    {
      country: 'Costa Rica',
      // '哥斯达黎加'
      chName: transform('areaCode_CostaRica'),
      countryCode: 'CR',
      code: '506',
    },
    {
      country: 'Grenada',
      // '格林纳达'
      chName: transform('areaCode_Grenada'),
      countryCode: 'GD',
      code: '1473',
    },
    {
      country: 'Greenland',
      // '格陵兰岛'
      chName: transform('areaCode_Greenland'),
      countryCode: 'GL',
      code: '299',
    },
    {
      country: 'Georgia',
      // '格鲁吉亚'
      chName: transform('areaCode_Georgia'),
      countryCode: 'GE',
      code: '995',
    },
    // /'古巴'
    { country: 'Cuba', chName: transform('areaCode_Cuba'), countryCode: 'CU', code: '53' },
    {
      country: 'Guadeloupe',
      // '瓜德罗普岛'
      chName: transform('areaCode_Guadeloupe'),
      countryCode: 'GP',
      code: '590',
    },
    {
      country: 'Guatemala',
      // '瓜地马拉'
      chName: transform('areaCode_Guatemala'),
      countryCode: 'GT',
      code: '502',
    },
    {
      country: 'Guam',
      // '关岛'
      chName: transform('areaCode_Guam'),
      countryCode: 'GU',
      code: '1671',
    },
    {
      country: 'Guyana',
      // '圭亚那'
      chName: transform('areaCode_Guyana'),
      countryCode: 'GY',
      code: '592',
    },
    {
      country: 'Kazakhstan',
      // '哈萨克斯坦'
      chName: transform('areaCode_Kazakhstan'),
      countryCode: 'KZ',
      code: '7',
    },
    {
      country: 'Haiti',
      // '海地'
      chName: transform('areaCode_Haiti'),
      countryCode: 'HT',
      code: '509',
    },
    {
      country: 'South Korea',
      // '韩国'
      chName: transform('areaCode_SouthKorea'),
      countryCode: 'KR',
      code: '82',
    },
    {
      country: 'Netherlands',
      // '荷兰'
      chName: transform('areaCode_Netherlands'),
      countryCode: 'NL',
      code: '31',
    },
    {
      country: 'Montenegro',
      // '黑山'
      chName: transform('areaCode_Montenegro'),
      countryCode: 'ME',
      code: '382',
    },
    {
      country: 'Honduras',
      // '洪都拉斯'
      chName: transform('areaCode_Honduras'),
      countryCode: 'HN',
      code: '504',
    },
    {
      country: 'Kiribati',
      // '基里巴斯'
      chName: transform('areaCode_Kiribati'),
      countryCode: 'KI',
      code: '686',
    },
    {
      country: 'Djibouti',
      // '吉布提'
      chName: transform('areaCode_Djibouti'),
      countryCode: 'DJ',
      code: '253',
    },
    {
      country: 'Kyrgyzstan',
      // '吉尔吉斯斯坦'
      chName: transform('areaCode_Kyrgyzstan'),
      countryCode: 'KG',
      code: '996',
    },
    {
      country: 'Guinea',
      // '几内亚'
      chName: transform('areaCode_Guinea'),
      countryCode: 'GN',
      code: '224',
    },
    {
      country: 'Guinea-Bissau',
      // '几内亚比绍共和国'
      chName: transform('areaCode_GuineaBissau'),
      countryCode: 'GW',
      code: '245',
    },
    {
      country: 'Canada',
      // '加拿大'
      chName: transform('areaCode_Canada'),
      countryCode: 'CA',
      code: '1',
    },
    {
      country: 'Ghana',
      // '加纳'
      chName: transform('areaCode_Ghana'),
      countryCode: 'GH',
      code: '233',
    },
    {
      country: 'Gabon',
      // '加蓬'
      chName: transform('areaCode_Gabon'),
      countryCode: 'GA',
      code: '241',
    },
    {
      country: 'Cambodia',
      // '柬埔寨'
      chName: transform('areaCode_Cambodia'),
      countryCode: 'KH',
      code: '855',
    },
    {
      country: 'Czech',
      // '捷克'
      chName: transform('areaCode_Czech'),
      countryCode: 'CZ',
      code: '420',
    },
    {
      country: 'Zimbabwe',
      // '津巴布韦'
      chName: transform('areaCode_Zimbabwe'),
      countryCode: 'ZW',
      code: '263',
    },
    {
      country: 'Cameroon',
      // '喀麦隆'
      chName: transform('areaCode_Cameroon'),
      countryCode: 'CM',
      code: '237',
    },
    {
      country: 'Qatar',
      // '卡塔尔'
      chName: transform('areaCode_Qatar'),
      countryCode: 'QA',
      code: '974',
    },
    {
      country: 'Cayman Islands',
      // '开曼群岛'
      chName: transform('areaCode_CaymanIslands'),
      countryCode: 'KY',
      code: '1345',
    },
    {
      country: 'Cape Verde',
      // '开普'
      chName: transform('areaCode_CapeVerde'),
      countryCode: 'CV',
      code: '238',
    },
    {
      country: 'Comoros',
      // '科摩罗'
      chName: transform('areaCode_Comoros'),
      countryCode: 'KM',
      code: '269',
    },
    {
      country: 'Kuwait',
      // '科威特'
      chName: transform('areaCode_Kuwait'),
      countryCode: 'KW',
      code: '965',
    },
    {
      country: 'Croatia',
      // '克罗地亚'
      chName: transform('areaCode_Croatia'),
      countryCode: 'HR',
      code: '385',
    },
    {
      country: 'Kenya',
      // /'肯尼亚'
      chName: transform('areaCode_Kenya'),
      countryCode: 'KE',
      code: '254',
    },
    {
      country: 'Cook Islands',
      // '库克群岛'
      chName: transform('areaCode_CookIslands'),
      countryCode: 'CK',
      code: '682',
    },
    {
      country: 'Curacao',
      // '库拉索'
      chName: transform('areaCode_Curacao'),
      countryCode: 'CW',
      code: '599',
    },
    {
      country: 'Latvia',
      // '拉脱维亚'
      chName: transform('areaCode_Latvia'),
      countryCode: 'LV',
      code: '371',
    },
    {
      country: 'Lesotho',
      // '莱索托'
      chName: transform('areaCode_Lesotho'),
      countryCode: 'LS',
      code: '266',
    },
    // '老挝'
    { country: 'Laos', chName: transform('areaCode_Laos'), countryCode: 'LA', code: '856' },
    {
      country: 'Lebanon',
      // '黎巴嫩'
      chName: transform('areaCode_Lebanon'),
      countryCode: 'LB',
      code: '961',
    },
    {
      country: 'Lithuania',
      // '立陶宛'
      chName: transform('areaCode_Lithuania'),
      countryCode: 'LT',
      code: '370',
    },
    {
      country: 'Liberia',
      // '利比里亚'
      chName: transform('areaCode_Liberia'),
      countryCode: 'LR',
      code: '231',
    },
    {
      country: 'Libya',
      // '利比亚'
      chName: transform('areaCode_Libya'),
      countryCode: 'LY',
      code: '218',
    },
    {
      country: 'Liechtenstein',
      // '列支敦士登'
      chName: transform('areaCode_Liechtenstein'),
      countryCode: 'LI',
      code: '423',
    },
    {
      country: 'Réunion Island',
      // '留尼汪'
      chName: transform('RéunionIsland'),
      countryCode: 'RE',
      code: '262',
    },
    {
      country: 'Luxembourg',
      // '卢森堡'
      chName: transform('areaCode_Luxembourg'),
      countryCode: 'LU',
      code: '352',
    },
    {
      country: 'Rwanda',
      // '卢旺达'
      chName: transform('areaCode_Rwanda'),
      countryCode: 'RW',
      code: '250',
    },
    {
      country: 'Romania',
      // '罗马尼亚'
      chName: transform('areaCode_Romania'),
      countryCode: 'RO',
      code: '40',
    },
    {
      country: 'Madagascar',
      // '马达加斯加'
      chName: transform('areaCode_Madagascar'),
      countryCode: 'MG',
      code: '261',
    },
    {
      country: 'Maldives',
      // '马尔代夫'
      chName: transform('areaCode_Maldives'),
      countryCode: 'MV',
      code: '960',
    },
    {
      country: 'Malta',
      // '马耳他'
      chName: transform('areaCode_Malta'),
      countryCode: 'MT',
      code: '356',
    },
    {
      country: 'Malawi',
      // '马拉维'
      chName: transform('areaCode_Malawi'),
      countryCode: 'MW',
      code: '265',
    },
    {
      country: 'Malaysia',
      // '马来西亚'
      chName: transform('areaCode_Malaysia'),
      countryCode: 'MY',
      code: '60',
    },
    // '马里'
    { country: 'Mali', chName: transform('areaCode_Mali'), countryCode: 'ML', code: '223' },
    {
      country: 'Macedonia',
      // '马其顿'
      chName: transform('areaCode_Macedonia'),
      countryCode: 'MK',
      code: '389',
    },
    {
      country: 'Martinique',
      // '马提尼克'
      chName: transform('areaCode_Martinique'),
      countryCode: 'MQ',
      code: '596',
    },
    {
      country: 'Mayotte',
      // '马约特'
      chName: transform('areaCode_Mayotte'),
      countryCode: 'YT',
      code: '269',
    },
    {
      country: 'Mauritius',
      // '毛里求斯'
      chName: transform('areaCode_Mauritius'),
      countryCode: 'MU',
      code: '230',
    },
    {
      country: 'Mauritania',
      // '毛里塔尼亚'
      chName: transform('areaCode_Mauritania'),
      countryCode: 'MR',
      code: '222',
    },
    {
      country: 'United States',
      // '美国'
      chName: transform('areaCode_UnitedStates'),
      countryCode: 'US',
      code: '1',
    },
    {
      country: 'American Samoa',
      // '美属萨摩亚'
      chName: transform('areaCode_AmericanSamoa'),
      countryCode: 'AS',
      code: '1684',
    },
    {
      country: 'Virgin Islands US',
      // '美属维尔京群岛'
      chName: transform('areaCode_VirginIslandsUS'),
      countryCode: 'VI',
      code: '1284',
    },
    {
      country: 'Mongolia',
      // '蒙古'
      chName: transform('areaCode_Mongolia'),
      countryCode: 'MN',
      code: '976',
    },
    {
      country: 'Montserrat',
      // '蒙特塞拉特岛'
      chName: transform('areaCode_Montserrat'),
      countryCode: 'MS',
      code: '1664',
    },
    {
      country: 'Bangladesh',
      // '孟加拉国'
      chName: transform('areaCode_Bangladesh'),
      countryCode: 'BD',
      code: '880',
    },
    // '秘鲁'
    { country: 'Peru', chName: transform('areaCode_Peru'), countryCode: 'PE', code: '51' },
    {
      country: 'Myanmar',
      // '缅甸'
      chName: transform('areaCode_Myanmar'),
      countryCode: 'MM',
      code: '95',
    },
    {
      country: 'Moldova',
      // '摩尔多瓦'
      chName: transform('areaCode_Moldova'),
      countryCode: 'MD',
      code: '373',
    },
    {
      country: 'Morocco',
      // '摩洛哥'
      chName: transform('areaCode_Morocco'),
      countryCode: 'MA',
      code: '212',
    },
    {
      country: 'Monaco',
      // '摩纳哥'
      chName: transform('areaCode_Monaco'),
      countryCode: 'MC',
      code: '377',
    },
    {
      country: 'Mozambique',
      // '莫桑比克'
      chName: transform('areaCode_Mozambique'),
      countryCode: 'MZ',
      code: '258',
    },
    {
      country: 'Mexico',
      // '墨西哥'
      chName: transform('areaCode_Mexico'),
      countryCode: 'MX',
      code: '52',
    },
    {
      country: 'Namibia',
      // '纳米比亚'
      chName: transform('areaCode_Namibia'),
      countryCode: 'NA',
      code: '264',
    },
    {
      country: 'South Africa',
      // '南非'
      chName: transform('areaCode_SouthAfrica'),
      countryCode: 'ZA',
      code: '27',
    },
    {
      country: 'Nepal',
      // '尼泊尔'
      chName: transform('areaCode_Nepal'),
      countryCode: 'NP',
      code: '977',
    },
    {
      country: 'Nicaragua',
      // '尼加拉瓜'
      chName: transform('areaCode_Nicaragua'),
      countryCode: 'NI',
      code: '505',
    },
    {
      country: 'Niger',
      // '尼日尔'
      chName: transform('areaCode_Niger'),
      countryCode: 'NE',
      code: '227',
    },
    {
      country: 'Nigeria',
      // '尼日利亚'
      chName: transform('areaCode_Nigeria'),
      countryCode: 'NG',
      code: '234',
    },
    {
      country: 'Norway',
      // '挪威'
      chName: transform('areaCode_Norway'),
      countryCode: 'NO',
      code: '47',
    },
    {
      country: 'Palau',
      // '帕劳'
      chName: transform('areaCode_Palau'),
      countryCode: 'PW',
      code: '680',
    },
    {
      country: 'Portugal',
      // '葡萄牙'
      chName: transform('areaCode_Portugal'),
      countryCode: 'PT',
      code: '351',
    },
    // '日本'
    { country: 'Japan', chName: transform('areaCode_Japan'), countryCode: 'JP', code: '81' },
    {
      country: 'Sweden',
      // '瑞典'
      chName: transform('areaCode_Sweden'),
      countryCode: 'SE',
      code: '46',
    },
    {
      country: 'Switzerland',
      // '瑞士'
      chName: transform('areaCode_Switzerland'),
      countryCode: 'CH',
      code: '41',
    },
    {
      country: 'El Salvador',
      // '萨尔瓦多'
      chName: transform('areaCode_ElSalvador'),
      countryCode: 'SV',
      code: '503',
    },
    {
      country: 'Samoa',
      // '萨摩亚'
      chName: transform('areaCode_Samoa'),
      countryCode: 'WS',
      code: '685',
    },
    {
      country: 'Serbia',
      // '塞尔维亚'
      chName: transform('areaCode_Serbia'),
      countryCode: 'RS',
      code: '381',
    },
    {
      country: 'Sierra Leone',
      // '塞拉利昂'
      chName: transform('areaCode_SierraLeone'),
      countryCode: 'SL',
      code: '232',
    },
    {
      country: 'Senegal',
      // '塞内加尔'
      chName: transform('areaCode_Senegal'),
      countryCode: 'SN',
      code: '221',
    },
    {
      country: 'Cyprus',
      // '塞浦路斯'
      chName: transform('areaCode_Cyprus'),
      countryCode: 'CY',
      code: '357',
    },
    {
      country: 'Seychelles',
      // '塞舌尔'
      chName: transform('areaCode_Seychelles'),
      countryCode: 'SC',
      code: '248',
    },
    {
      country: 'Saudi Arabia',
      // '沙特阿拉伯'
      chName: transform('areaCode_SaudiArabia'),
      countryCode: 'SA',
      code: '966',
    },
    {
      country: 'Saint Pierre and Miquel',
      // '圣彼埃尔和密克隆岛'
      chName: transform('areaCode_SaintPierreandMiquel'),
      countryCode: 'PM',
      code: '508',
    },
    {
      country: 'Sao Tome and Principe',
      // '圣多美和普林西比'
      chName: transform('areaCode_SaoTomeandPrincipe'),
      countryCode: 'ST',
      code: '239',
    },
    {
      country: 'Saint Kitts and Nevis',
      // '圣基茨和尼维斯'
      chName: transform('areaCode_SaintKittsandNevis'),
      countryCode: 'KN',
      code: '1869',
    },
    {
      country: 'Saint Lucia',
      // '圣露西亚'
      chName: transform('areaCode_SaintLucia'),
      countryCode: 'LC',
      code: '1758',
    },
    {
      country: 'Sint Maarten (Dutch Par',
      // '圣马丁岛（荷兰部分'
      chName: transform('areaCode_SintMaartenDutchPar'),
      countryCode: 'SX',
      code: '1721',
    },
    {
      country: 'San Marino',
      // '圣马力诺'
      chName: transform('areaCode_SanMarino'),
      countryCode: 'SM',
      code: '378',
    },
    {
      country: 'Saint Vincent and The G',
      // '圣文森特和格林纳丁'
      chName: transform('areaCode_SaintVincentandTheG'),
      countryCode: 'VC',
      code: '1784',
    },
    {
      country: 'Sri Lanka',
      // '斯里兰卡'
      chName: transform('areaCode_SriLanka'),
      countryCode: 'LK',
      code: '94',
    },
    {
      country: 'Slovakia',
      // '斯洛伐克'
      chName: transform('areaCode_Slovakia'),
      countryCode: 'SK',
      code: '421',
    },
    {
      country: 'Slovenia',
      // '斯洛文尼亚'
      chName: transform('areaCode_Slovenia'),
      countryCode: 'SI',
      code: '386',
    },
    {
      country: 'Swaziland',
      // '斯威士兰'
      chName: transform('areaCode_Swaziland'),
      countryCode: 'SZ',
      code: '268',
    },
    {
      country: 'Sudan',
      // '苏丹'
      chName: transform('areaCode_Sudan'),
      countryCode: 'SD',
      code: '249',
    },
    {
      country: 'Suriname',
      // '苏里南'
      chName: transform('areaCode_Suriname'),
      countryCode: 'SR',
      code: '597',
    },
    {
      country: 'Solomon Islands',
      // '所罗门群岛'
      chName: transform('areaCode_SolomonIslands'),
      countryCode: 'SB',
      code: '677',
    },
    {
      country: 'Somalia',
      // '索马里'
      chName: transform('areaCode_Somalia'),
      countryCode: 'SO',
      code: '252',
    },
    {
      country: 'Tajikistan',
      // '塔吉克斯坦'
      chName: transform('areaCode_Tajikistan'),
      countryCode: 'TJ',
      code: '992',
    },
    {
      country: 'Thailand',
      // '泰国'
      chName: transform('areaCode_Thailand'),
      countryCode: 'TH',
      code: '66',
    },
    {
      country: 'Tanzania',
      // '坦桑尼亚'
      chName: transform('areaCode_Tanzania'),
      countryCode: 'TZ',
      code: '255',
    },
    {
      country: 'Tonga',
      // '汤加'
      chName: transform('areaCode_Tonga'),
      countryCode: 'TO',
      code: '676',
    },
    {
      country: 'Turks and Caicos Island',
      // '特克斯和凯科斯群岛'
      chName: transform('areaCode_TurksandCaicosIsland'),
      countryCode: 'TC',
      code: '1649',
    },
    {
      country: 'Trinidad and Tobago',
      // '特立尼达和多巴哥'
      chName: transform('areaCode_TrinidadandTobago'),
      countryCode: 'TT',
      code: '1868',
    },
    {
      country: 'Tunisia',
      // '突尼斯'
      chName: transform('areaCode_Tunisia'),
      countryCode: 'TN',
      code: '216',
    },
    {
      country: 'Turkey',
      // '土耳其'
      chName: transform('areaCode_Turkey'),
      countryCode: 'TR',
      code: '90',
    },
    {
      country: 'Turkmenistan',
      // '土库曼斯坦'
      chName: transform('areaCode_Turkmenistan'),
      countryCode: 'TM',
      code: '993',
    },
    {
      country: 'Vanuatu',
      // '瓦努阿图'
      chName: transform('areaCode_Vanuatu'),
      countryCode: 'VU',
      code: '678',
    },
    {
      country: 'Venezuela',
      // '委内瑞拉'
      chName: transform('areaCode_Venezuela'),
      countryCode: 'VE',
      code: '58',
    },
    {
      country: 'Brunei',
      // '文莱'
      chName: transform('areaCode_Brunei'),
      countryCode: 'BN',
      code: '673',
    },
    {
      country: 'Uganda',
      // '乌干达'
      chName: transform('areaCode_Uganda'),
      countryCode: 'UG',
      code: '256',
    },
    {
      country: 'Ukraine',
      // '乌克兰'
      chName: transform('areaCode_Ukraine'),
      countryCode: 'UA',
      code: '380',
    },
    {
      country: 'Uruguay',
      // '乌拉圭'
      chName: transform('areaCode_Uruguay'),
      countryCode: 'UY',
      code: '598',
    },
    {
      country: 'Uzbekistan',
      // '乌兹别克斯坦'
      chName: transform('areaCode_Uzbekistan'),
      countryCode: 'UZ',
      code: '998',
    },
    {
      country: 'Spain',
      // '西班牙'
      chName: transform('areaCode_Spain'),
      countryCode: 'ES',
      code: '34',
    },
    {
      country: 'Greece',
      // '希腊'
      chName: transform('areaCode_Greece'),
      countryCode: 'GR',
      code: '30',
    },
    {
      country: 'Ivory Coast',
      // '象牙海岸'
      chName: transform('areaCode_IvoryCoast'),
      countryCode: 'CI',
      code: '225',
    },
    {
      country: 'Singapore',
      // '新加坡'
      chName: transform('areaCode_Singapore'),
      countryCode: 'SG',
      code: '65',
    },
    {
      country: 'New Caledonia',
      // '新喀里多尼亚'
      chName: transform('areaCode_NewCaledonia'),
      countryCode: 'NC',
      code: '687',
    },
    {
      country: 'New Zealand',
      // '新西兰
      chName: transform('areaCode_NewZealand'),
      countryCode: 'NZ',
      code: '64',
    },
    {
      country: 'Hungary',
      // '匈牙利'
      chName: transform('areaCode_Hungary'),
      countryCode: 'HU',
      code: '36',
    },
    {
      country: 'Syria',
      // '叙利亚'
      chName: transform('areaCode_Syria'),
      countryCode: 'SY',
      code: '963',
    },
    {
      country: 'Jamaica',
      // '牙买加'
      chName: transform('areaCode_Jamaica'),
      countryCode: 'JM',
      code: '1876',
    },
    {
      country: 'Armenia',
      // '亚美尼亚'
      chName: transform('areaCode_Armenia'),
      countryCode: 'AM',
      code: '374',
    },
    {
      country: 'Yemen',
      // '也门'
      chName: transform('areaCode_Yemen'),
      countryCode: 'YE',
      code: '967',
    },
    {
      country: 'Iraq',
      // '伊拉克'
      chName: transform('areaCode_Iraq'),
      countryCode: 'IQ',
      code: '964',
    },
    // '伊朗'
    { country: 'Iran', chName: transform('areaCode_Iran'), countryCode: 'IR', code: '98' },
    {
      country: 'Israel',
      // '以色列'
      chName: transform('areaCode_Israel'),
      countryCode: 'IL',
      code: '972',
    },
    {
      country: 'Italy',
      // '意大利'
      chName: transform('areaCode_Italy'),
      countryCode: 'IT',
      code: '39',
    },
    // '印度'
    { country: 'India', chName: transform('areaCode_India'), countryCode: 'IN', code: '91' },
    {
      country: 'Indonesia',
      // '印度尼西亚'
      chName: transform('areaCode_Indonesia'),
      countryCode: 'ID',
      code: '62',
    },
    {
      country: 'United Kingdom',
      // '英国'
      chName: transform('areaCode_UnitedKingdom'),
      countryCode: 'GB',
      code: '44',
    },
    {
      country: 'Virgin Islands British',
      // '英属处女群岛'
      chName: transform('areaCode_VirginIslandsBritish'),
      countryCode: 'VG',
      code: '1340',
    },
    {
      country: 'Jordan',
      // '约旦'
      chName: transform('areaCode_Jordan'),
      countryCode: 'JO',
      code: '962',
    },
    {
      country: 'Vietnam',
      // '越南'
      chName: transform('areaCode_Vietnam'),
      countryCode: 'VN',
      code: '84',
    },
    {
      country: 'Zambia',
      // '赞比亚'
      chName: transform('areaCode_Zambia'),
      countryCode: 'ZM',
      code: '260',
    },
    // '乍得'
    { country: 'Chad', chName: transform('areaCode_Chad'), countryCode: 'TD', code: '235' },
    {
      country: 'Gibraltar',
      // '直布罗陀'
      chName: transform('areaCode_Gibraltar'),
      countryCode: 'GI',
      code: '350',
    },
    // '智利'
    { country: 'Chile', chName: transform('areaCode_Chile'), countryCode: 'CL', code: '56' },
    {
      country: 'Central African Republi',
      // '中非共和国'
      chName: transform('areaCode_CentralAfricanRepubli'),
      countryCode: 'CF',
      code: '236',
    },
  ],
}
